import { PayloadAction } from "@reduxjs/toolkit";
import { Nullable } from "../../types/nullable";
import { getErrorMessageFromUnknownErrorType } from "../../utils/handle-error";

interface BaseSlice<T> {
  loading: boolean;
  error: Nullable<string>;
  data: Nullable<T>;
}

const _getBaseSliceInitialState = <T>(
  initialData: Nullable<T> = null
): BaseSlice<T> => ({
  loading: false,
  error: null,
  data: initialData,
});

const _getBaseReducers = <T>(initialData: Nullable<T> = null) => ({
  setData: (state: BaseSlice<T>, { payload }: PayloadAction<Nullable<T>>) => {
    state.data = payload;
  },
  setLoading: (state: BaseSlice<T>, { payload }: PayloadAction<boolean>) => {
    state.loading = payload;
  },
  setError: (
    state: BaseSlice<T>,
    { payload }: PayloadAction<unknown | null>
  ) => {
    state.error = payload ? getErrorMessageFromUnknownErrorType(payload) : null;
  },
  clearData: (state: BaseSlice<T>) => {
    state.data = initialData;
    state.error = null;
    state.loading = false;
  },
});

export const getBaseSlice = <T>(initialData: Nullable<T> = null) => ({
  initialState: _getBaseSliceInitialState<T>(initialData),
  reducers: _getBaseReducers<T>(initialData),
});
